/**
 * TranslateAction Component
 * Action chip for translating INPUT TEXT
 * Shows loading state in chip when processing
 */
import React, { useRef } from 'react';
import { Languages } from 'lucide-react';
import ActionChip from '../ActionChip';
import LanguageSelector from '../LanguageSelector';
import { ACTION_TYPES, ACTIONS_CONFIG } from '../constants';

const TranslateAction = ({ 
  isDropdownOpen,
  selectedLanguages,
  onToggleDropdown,
  onToggleLanguage,
  onCloseDropdown,
  onExecute,
  isProcessing = false,
  isDisabled = false,
  disabledReason = 'Digite algo no campo de texto para traduzir',
}) => {
  const anchorRef = useRef(null);
  const config = ACTIONS_CONFIG[ACTION_TYPES.TRANSLATE];

  const handleClick = () => {
    if (isDisabled || isProcessing) return;
    onToggleDropdown();
  };

  return (
    <div ref={anchorRef} style={{ position: 'relative' }}>
      <ActionChip
        icon={Languages}
        label={config.label}
        isActive={isDropdownOpen || selectedLanguages.length > 0}
        isDisabled={isDisabled}
        isProcessing={isProcessing}
        processingLabel="Traduzindo..."
        hasDropdown={true}
        isDropdownOpen={isDropdownOpen}
        onClick={handleClick}
        badge={!isProcessing && selectedLanguages.length > 0 ? selectedLanguages.length : null}
        tooltip={isDisabled ? disabledReason : null}
      />

      <LanguageSelector
        isOpen={isDropdownOpen && !isDisabled && !isProcessing}
        selectedLanguages={selectedLanguages}
        onToggleLanguage={onToggleLanguage}
        onClose={onCloseDropdown}
        onExecute={onExecute}
        isProcessing={isProcessing}
        anchorRef={anchorRef}
        maxLanguages={config.maxLanguages}
        title="Traduzir para:"
        actionType={ACTION_TYPES.TRANSLATE}
      />
    </div>
  );
};

export default TranslateAction;